import { Container } from 'aurelia-framework';
import React from 'react';

import { AcuritySearchApi } from '~/api/acurity-search-api';
import { EntitySearchHolder } from '~/components/entity-search/entity-search-holder/entity-search-holder';
import { AutocompleteColumnHeader } from '~/components/field/common/autocomplete/autocomplete-react';
import { Autocomplete } from '~/components/field/common/autocomplete/autocomplete';

interface Props {
	label: string;
	name: string;
	title: string;
	columnName: string;
	columnHeaders: AutocompleteColumnHeader[];
	value: string;
	description: string;
	remoteOptions: { [option: string]: any | undefined };
	onSelect: (record?: { [columnName: string]: string }) => void;
	handleRefInputElemChange: (refInputElem: HTMLInputElement) => void;
	displayResultsOnFocus: boolean;
	resultsDropUp: boolean;
}

const styles = {
	input: 'a-entity-search-input-module__input',
	autocomplete: 'a-entity-search-input-module__autocomplete',
};

export class EntitySearchAutocomplete extends React.Component<Props> {
	private readonly acuritySearchApi: AcuritySearchApi =
		Container.instance.get(AcuritySearchApi);

	private readonly handleRefInputElemChange = (
		refInputElem: HTMLInputElement,
	): void => {
		this.props.handleRefInputElemChange(refInputElem);
	};

	public render() {
		const {
			label,
			name,
			title,
			columnName,
			columnHeaders,
			value,
			description,
			remoteOptions,
			onSelect,
			displayResultsOnFocus,
			resultsDropUp,
		} = this.props;
		return (
			<EntitySearchHolder label={label} name={name} title={title}>
				<Autocomplete
					id={title}
					columnHeaders={columnHeaders}
					columnName={columnName}
					value={value}
					remote={this.acuritySearchApi}
					remoteOptions={remoteOptions}
					onSelect={onSelect}
					displayResultsOnFocus={displayResultsOnFocus}
					autocomplete={'off'}
					allowUserInput={false}
					description={description}
					entitySearchStyles={styles}
					handleRefInputElemChange={this.handleRefInputElemChange}
					resultsDropUp={resultsDropUp}
				/>
			</EntitySearchHolder>
		);
	}
}
